// import React, { useState, Fragment, Component } from 'react'
// import React, { Fragment, useState, Component, useRef, useEffect } from "react"

import React, { Fragment, useState, Component, useRef, useEffect } from "react";

import moment from "moment";
import Shimmer from "react-shimmer-effect";
import {
  Container,
  Row,
  Col,
  CardBody,
  Card,
  CardTitle,
  CardSubtitle,
  Tooltip,
  Alert,
  Button,
  Table,
  Spinner,
} from "reactstrap";
import { ConfirmAlert } from "../../../../helpers/ui/alert";

import { Link, useHistory, useParams } from "react-router-dom";
import { withRouter } from "react-router";
import { AvField, AvForm } from "availity-reactstrap-validation";

import apiResponse from "../../../../services/apiResponse";

import DetailBloc from "./Blocs/DetailBloc";
import CustomSelect from "../../GlobalComponents/CustomSelect";

const createYearOption = (startYear = 2000) => {
  var currentYear = new Date().getFullYear() + 10,
    years = [];
  startYear = startYear || 1980;
  while (startYear <= currentYear) {
    var newObj = {};
    var year = startYear++;
    newObj["label"] = year;
    newObj["value"] = year;
    years.push(newObj);
  }
  return years;
};

const createMonthOptions = () => {
  var months = [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember",
  ];

  return months.map(function (month, i) {
    var newObj = {};
    newObj["label"] = month;
    newObj["value"] = ++i;

    return newObj;
  });
};
const formatDateNoTime = (value) => {
  if (value != "-" && value != "" && value != null) {
    let date = new Date(value);
    const day = date.toLocaleString("id-ID", { day: "2-digit" });
    const month = date.toLocaleString("id-ID", { month: "2-digit" });
    const year = date.toLocaleString("id-ID", { year: "numeric" });

    return day + "-" + month + "-" + year;
  } else {
    return "-";
  }
};
const SortByName = (a, b) => {
  var anewdate = a.tanggalSk.split("-").reverse().join("-");
  var bnewdate = b.tanggalSk.split("-").reverse().join("-");
  var aName = bnewdate;
  var bName = anewdate;
  return aName < bName ? -1 : aName > bName ? 1 : 0;
};
class IndexView extends Component {
  detailBloc = new DetailBloc();

  userdata = JSON.parse(localStorage.getItem("userdata"));

  constructor(props) {
    super(props);
    this.state = {
      start_date: moment().startOf("month").format("YYYY-MM-DD"),
      end_date: moment().endOf("month").format("YYYY-MM-DD"),
      // start_date : '',
      // end_date : '',
      yearOptions: createYearOption(new Date().getFullYear() - 30),
      monthOptions: createMonthOptions(),
      year: new Date().getFullYear(),
      month: moment().format("M"),
      detail: null,
    };

    this.activeRef = React.createRef();
  }

  componentDidMount() {
    // const activeRef = useRef();
    const queryParams = new URLSearchParams(this.props.location.search);
    const uuid = queryParams.get("uuid");

    this.detailBloc.fetchDetail({ uuid: uuid });
    this.detailBloc.detailChannel.subscribe((result) => {
      switch (result.status) {
        case apiResponse.COMPLETED:
          if (result.data.status) {
            let response = result.data.response.detail;
            this.setState({
              detail: response,
            });
          }
          break;
        case apiResponse.ERROR:
          break;
        default:
          break;
      }
    });
  }

  componentWillUnmount() {
    this.detailBloc.detailChannel?.unsubscribe();
  }

  reset = () => {
    this.setState({ start_date: "", end_date: "" });
  };

  reloadActiveRef = () => this.activeRef.current.setTokenAPI();

  confirmResponse = (response) => {
    let forState = {};
    switch (response) {
      case "cancel":
        forState = {
          confirm: false,
        };
        break;
      case "confirm":
        forState = {
          loading: true,
          confirm: false,
        };
        if (this.state.runType == 5) {
          this.sendToBKN();
        } else if (this.state.runType == 6) {
          this.sendToSIMPEG();
        }
        break;
      case "success":
        forState = {
          success: false,
          redirect: true,
        };
        break;
      case "failed":
        forState = {
          failed: false,
        };
        break;
      default:
    }
    this.setState(forState);
  };

  render() {
    let filter = {
      start_date: this.state.start_date,
      end_date: this.state.end_date,
    };

    return (
      <Fragment>
        <Container fluid>
          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <CardTitle>Detail Data Pemadanan</CardTitle>
                  <CardSubtitle className="mb-1">
                    Informasi Detail Data Pemadanan
                  </CardSubtitle>
                  <hr />
                  <AvForm className="needs-validation">
                    <Row className="mb-1">
                      <label className="col-md-3">NIP</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_nip !== null
                              ? this.state.detail.padanan_nip
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    {/* <Row className="mb-1">
                      <label className="col-md-3">NIP (Kemenkeu)</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_nip_kemenkeu !== null
                              ? this.state.detail.padanan_nip_kemenkeu
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mb-1">
                      <label className="col-md-3">Nama</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_nmpeg !== null
                              ? this.state.detail.padanan_nmpeg
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    {/* <Row className="mb-1">
                      <label className="col-md-3">Nama (Kemenkeu)</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_nmpeg_kemenkeu !== null
                              ? this.state.detail.padanan_nmpeg_kemenkeu
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row> */}

                    <Row className="mb-1">
                      <label className="col-md-3">Jabatan</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_kdjab !== null
                              ? this.state.detail.padanan_kdjab
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <label className="col-md-3">Jabatan (Kemenkeu)</label>
                      <Col md="9">
                        {this.state.detail ? (
                          <>
                            {this.state.detail.padanan_kdjab_kemenkeu !== null
                              ? this.state.detail.padanan_kdjab_kemenkeu
                              : "-"}
                          </>
                        ) : (
                          <Shimmer>
                            <div style={{ width: 68, height: 15 }}></div>
                          </Shimmer>
                        )}
                      </Col>
                    </Row>

                    <hr />

                    <Row className="mb-1">
                      {/* <Col md="6">
                        <div className="table-responsive">
                          <Table className="table table-striped table-bordered">
                            <thead className="table-primary">
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                }}
                              >
                                <th
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                  colSpan={5}
                                  width="95%"
                                >
                                  SIMPEG
                                </th>
                                <th
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                  rowSpan={2}
                                  width="5%"
                                >
                                  Aksi
                                </th>
                              </tr>
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                              >
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Gol 
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kedudukan
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Status Kawin
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Status Keluarga
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.loadingTable == false ? (
                                this.state.simpegServiceJabatan.length > 0 ? (
                                  this.state.simpegServiceJabatan.map(
                                    (data, index) => {
                                      const databknServiceJabatan =
                                        this.state.bknServiceJabatan;
                                      const found = databknServiceJabatan.some(
                                        (el) =>
                                          el.nomorSk.trim().toLowerCase() ===
                                          data.position_history_decree_number
                                            .trim()
                                            .toLowerCase()
                                      );

                                      return (
                                        <tr
                                          id={"tr_jabatan_simpeg_" + index}
                                          style={{
                                            border:
                                              "1px solid rgb(200, 204, 225)",
                                          }}
                                        >
                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-left text-success"
                                                : "text-left"
                                            }
                                          >
                                            {
                                              data.position_history_position_name
                                            }
                                          </td>
                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-left text-success"
                                                : "text-left"
                                            }
                                          >
                                            {
                                              data.position_history_decree_number
                                            }
                                          </td>
                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-center text-success"
                                                : "text-center"
                                            }
                                          >
                                            {formatDateNoTime(
                                              data.position_history_decree_date
                                            )}
                                          </td>
                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-center text-success"
                                                : "text-center"
                                            }
                                          >
                                            {formatDateNoTime(
                                              data.position_history_tmt_position_date
                                            )}
                                          </td>
                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-center text-success"
                                                : "text-center"
                                            }
                                          >
                                            {data?.document != null ? (
                                              <a
                                                target={"_blank"}
                                                href={
                                                  data?.document?.documents_path
                                                }
                                              >
                                                Download
                                              </a>
                                            ) : (
                                              "-"
                                            )}
                                          </td>

                                          <td
                                            className={
                                              data.position_history_is_bkn ==
                                                1 || found
                                                ? "text-center text-success"
                                                : "text-center"
                                            }
                                          >
                                            {
                                              data.position_history_is_bkn ==
                                              null ? (
                                                <span>
                                                  <button
                                                    className="btn btn-primary btn-sm"
                                                    id={
                                                      "proses_" +
                                                      data.position_history_id
                                                    }
                                                    onClick={() => {
                                                      this.setState({
                                                        process_uuid:
                                                          data.position_history_uuid,
                                                        confirm: true,
                                                        runType: 5,
                                                        confirmInfo:
                                                          "Apakah anda yakin akan Mengirimkan data ini ke BKN?",
                                                      });
                                                    }}
                                                    style={{
                                                      marginRight: "2px",
                                                      padding: "2px 5px",
                                                    }}
                                                  >
                                                    <i className="uil-check-square"></i>
                                                  </button>
                                                  <Tooltip
                                                    style={{
                                                      marginBottom: 2,
                                                    }}
                                                    placement="top"
                                                    isOpen={
                                                      this.state[
                                                        "detail_simpeg_" +
                                                          data.position_history_id
                                                      ]
                                                    }
                                                    target={
                                                      "proses_" +
                                                      data.position_history_id
                                                    }
                                                    toggle={() => {
                                                      this.setState({
                                                        ["detail_simpeg_" +
                                                        data.position_history_id]:
                                                          !this.state[
                                                            "detail_simpeg_" +
                                                              data.position_history_id
                                                          ],
                                                      });
                                                    }}
                                                  >
                                                    Kirim Ke BKN
                                                  </Tooltip>
                                                </span>
                                              ) : (
                                                ""
                                              )
                                            }
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )
                                ) : (
                                  <tr style={{ border: "1px solid #c8cce1" }}>
                                    <td colSpan="5" className="text-center">
                                      Tidak Ada Data
                                    </td>
                                  </tr>
                                )
                              ) : (
                                <tr style={{ border: "1px solid #c8cce1" }}>
                                  <td colSpan="5" className="text-center">
                                    <Spinner className="m-2" color="primary" />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col> */}
                      <Col md="6">
                        <div className="table-responsive">
                          <Table className="table table-striped table-bordered">
                            <thead className="table-primary">
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                }}
                              >
                                <th
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                  colSpan={5}
                                  width="95%"
                                >
                                  SIMPEG
                                </th>
                              </tr>
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                              >
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Kawin
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kedudukan Hukum
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Tipe Jabatan
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Satker
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Golongan
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.detail !== null ? (
                                <tr
                                  id="tr_jabatan_simpeg_testing"
                                  style={{
                                    border: "1px solid rgb(200, 204, 225)",
                                  }}
                                >
                                  <td className="text-center">
                                    {this.state.detail.padanan_kdkawin ?? "-"} -{" "}
                                    {this.state.detail
                                      .padanan_kdkawin_deskripsi ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail.padanan_kdduduk ?? "-"} -{" "}
                                    {this.state.detail
                                      .padanan_kdduduk_deskripsi ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail
                                      .padanan_kdjab_type_kemenkeu ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail.padanan_kdsatker ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail.padanan_kdgol ?? "-"}
                                  </td>
                                </tr>
                              ) : (
                                <tr style={{ border: "1px solid #c8cce1" }}>
                                  <td colSpan="6" className="text-center">
                                    <Spinner className="m-2" color="primary" />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>

                      {/* PEMADANAN DATA */}

                      <Col md="6">
                        <div className="table-responsive">
                          <Table className="table table-striped table-bordered">
                            <thead className="table-primary">
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                }}
                              >
                                <th
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                  colSpan={5}
                                  width="95%"
                                >
                                  Gaji Web
                                </th>
                              </tr>
                              <tr
                                style={{
                                  border: "1px solid rgb(200, 204, 225)",
                                  backgroundColor: "rgb(255, 250, 233)",
                                }}
                              >
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Kawin
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kedudukan Hukum
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Tipe Jabatan
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Satker
                                </td>
                                <td
                                  className="text-center align-middle"
                                  style={{
                                    backgroundColor: "rgb(255, 250, 233)",
                                  }}
                                >
                                  Kode Golongan
                                </td>
                              </tr>
                            </thead>
                            <tbody>
                              {this.state.detail !== null ? (
                                <tr
                                  id="tr_jabatan_simpeg_testing"
                                  style={{
                                    border: "1px solid rgb(200, 204, 225)",
                                  }}
                                >
                                  <td className="text-center">
                                    {this.state.detail
                                      .padanan_kdkawin_kemenkeu ?? "-"}{" "}
                                    -{" "}
                                    {this.state.detail
                                      .padanan_kdkawin_deskripsi ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {" "}
                                    {this.state.detail
                                      .padanan_kdduduk_kemenkeu ?? "-"}{" "}
                                    -{" "}
                                    {this.state.detail
                                      .padanan_kdduduk_deskripsi ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail
                                      .padanan_kdjab_type_kemenkeu ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {" "}
                                    {this.state.detail
                                      .padanan_kdsatker_kemenkeu ?? "-"}
                                  </td>
                                  <td className="text-center">
                                    {this.state.detail.padanan_kdgol_kemenkeu ??
                                      "-"}
                                  </td>
                                </tr>
                              ) : (
                                <tr style={{ border: "1px solid #c8cce1" }}>
                                  <td colSpan="6" className="text-center">
                                    <Spinner className="m-2" color="primary" />
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </Col>
                    </Row>

                    <Row className="mb-1">
                      <Col md="3">
                        {" "}
                        <Link
                          to="/kepegawaian/pemadanan.html?"
                          className="waves-effect"
                        >
                          <Button color="danger">
                            <i className="uil-arrow-left"></i> Kembali
                          </Button>
                        </Link>
                      </Col>
                      {/* <Col md="9"> */}

                      {/* </Col> */}
                    </Row>
                  </AvForm>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </Fragment>
    );
  }
}

//export default IndexView
export default withRouter(IndexView);
